export default {
  /**
   * 系统配置
   */
  // 系统配置分页查询
  QUERY_SYSCONFIG_PAGE: '/maindata/sysConfig/queryPage',
  QUERY_SYSCONFIG_BY_ID: '/maindata/sysConfig/queryById',
  // 系统配置保存
  SAVE_SYSCONFIG: '/maindata/sysConfig/save',
  // 系统配置保存
  DELETE_SYSCONFIG: '/maindata/sysConfig/delete',
  // 系统配置获取根据公司
  GET_SYSCONFIG_BY_COMPANY: '/maindata/sysConfig/getSysConfigByCompany',
  // 系统配置获取根据部门
  GET_SYSCONFIG_BY_DEPART: '/maindata/sysConfig/getSysConfigByDepart',
};
